import { useEffect } from "react";
import { observeElementOnScreen } from "../../helpers/utils";

import ButtonUI from "@UI/ButtonUI";

import img1 from "./img/img1.webp";
import img2 from "./img/img2.webp";
import img3 from "./img/img3.webp";
import img4 from "./img/img4.webp";
import img5 from "./img/img5.webp";

import img1m from "./img/img1m.webp";
import img2m from "./img/img2m.webp";
import img3m from "./img/img3m.webp";
import img4m from "./img/img4m.webp";
import img5m from "./img/img5m.webp";

import ym from "react-yandex-metrika";

import { createLinkClick } from '@utils'

import "./style.scss";

const HowItWorks = () => {
    const refs = [];

    useEffect(() => {
        const observers = refs.forEach((_, idx) => observeElementOnScreen(refs[idx], -100)) || [];
        return () => observers.forEach((i) => i?.disconnect());
    }, []);

    const handleClick = () => {
        ym("reachGoal", 'click_connect_instrument');
        createLinkClick('#footer');
    }


    return (
        <div className="how" id="how">
            <span className="how__title">Как работает сервис?</span>
            <div className="how__container">
                <div className="how__cards">
                    {steps.map((step, index) => (
                        <div key={index} className={`how__entry ${index === 0 ? "how__entry_span" : ""}`} ref={(r) => refs.push(r)}>
                            <img src={step.img} alt="" className="how__entry-img" />
                            <img src={step.imgm} alt="" className="how__entry-imgm" />
                            <div className={`how__block ${step.isLimitation ? "how__block_limitation" : ""}`}>
                                <span className={`how__block-title ${index === 0 ? "how__block-title_first" : ""}`}>{step.title}</span>
                                <span className="how__block-sub">{step.sub}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <ButtonUI className='how__btn-link' btnRef={(rB) => refs.push(rB)} label="Подключить инструмент" onClick={handleClick} />
        </div>
    );
};

const steps = [
    {
        img: img1,
        imgm: img1m,
        title: "Точка входа",
        sub: (
            <>
                Человек совершает покупку на&nbsp;сайте&nbsp;партнёра&nbsp;и&nbsp;видит&nbsp;предложение: 
                <br />
                «Получите подарок»
            </>
        ),
        isLimitation: false,
    },
    {
        img: img2,
        imgm: img2m,
        title: "Выбор предложения",
        sub: "Пользователь открывает список подарков и выбирает самый интересный",
        isLimitation: true,
    },
    {
        img: img3,
        imgm: img3m,
        title: "Подтверждение",
        sub: "Человек отвечает на пару простых вопросов, оставляет свои контакты и получает подарок",
        isLimitation: true,
    },
    {
        img: img4,
        imgm: img4m,
        title: "Сбор контактов",
        sub: "Также мы можем собирать настоящие номера телефонов и узнавать больше о людях с помощью коротких опросов",
        isLimitation: true,
    },
    {
        img: img5,
        imgm: img5m,
        title: "Email - коммуникация",
        sub: "Мы напоминаем о себе по email — шлём полезные предложения и приглашаем вернуться за подарком",
        isLimitation: true,
    },
];

export default HowItWorks;
